
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("9yOl0"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("9yOl0", function(module, exports) {

let $6f5e560dcc8fec94$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6f5e560dcc8fec94$var$load("dIzOY"),
    $6f5e560dcc8fec94$var$load("alXrq"),
    $6f5e560dcc8fec94$var$load("2YffH"),
    $6f5e560dcc8fec94$var$load("iDB1L"),
    $6f5e560dcc8fec94$var$load("eEyVs"),
    $6f5e560dcc8fec94$var$load("6mHrv"),
    $6f5e560dcc8fec94$var$load("awWN9"),
    $6f5e560dcc8fec94$var$load("agAjs"),
    $6f5e560dcc8fec94$var$load("9CYct"),
    $6f5e560dcc8fec94$var$load("iIoyG"),
    $6f5e560dcc8fec94$var$load("2xn4F"),
    $6f5e560dcc8fec94$var$load("hZtKG"),
    $6f5e560dcc8fec94$var$load("iNmaF"),
    $6f5e560dcc8fec94$var$load("lVO3w"),
    $6f5e560dcc8fec94$var$load("hyzoX"),
    $6f5e560dcc8fec94$var$load("h9Ed7"),
    $6f5e560dcc8fec94$var$load("eBRUf"),
    $6f5e560dcc8fec94$var$load("j8gSv"),
    $6f5e560dcc8fec94$var$load("8hnOL"),
    $6f5e560dcc8fec94$var$load("gVbhn"),
    $6f5e560dcc8fec94$var$load("8A3nE"),
    $6f5e560dcc8fec94$var$load("8YSo7"),
    $6f5e560dcc8fec94$var$load("g7ggm"),
    $6f5e560dcc8fec94$var$load("9S9Mz"),
    $6f5e560dcc8fec94$var$load("kiGNy"),
    $6f5e560dcc8fec94$var$load("fuKGN"),
    $6f5e560dcc8fec94$var$load("4IYLb"),
    $6f5e560dcc8fec94$var$load("7Ftdh"),
    $6f5e560dcc8fec94$var$load("g9CVe"),
    $6f5e560dcc8fec94$var$load("7oiUM"),
    $6f5e560dcc8fec94$var$load("8t3po"),
    $6f5e560dcc8fec94$var$load("855o0"),
    $6f5e560dcc8fec94$var$load("8MfZE"),
    $6f5e560dcc8fec94$var$load("hv4mn"),
    $6f5e560dcc8fec94$var$load("dek7I"),
    $6f5e560dcc8fec94$var$load("3SmkN"),
    $6f5e560dcc8fec94$var$load("dYtBN"),
    $6f5e560dcc8fec94$var$load("kNV5Y"),
    $6f5e560dcc8fec94$var$load("6wr18"),
    $6f5e560dcc8fec94$var$load("kjZZD"),
    $6f5e560dcc8fec94$var$load("4qa0a"),
    $6f5e560dcc8fec94$var$load("iPNfy"),
    $6f5e560dcc8fec94$var$load("9u7sS"),
    $6f5e560dcc8fec94$var$load("1fem1"),
    $6f5e560dcc8fec94$var$load("Wowvf"),
    $6f5e560dcc8fec94$var$load("ffEVr"),
    $6f5e560dcc8fec94$var$load("hhss7"),
    $6f5e560dcc8fec94$var$load("dTsOE"),
    $6f5e560dcc8fec94$var$load("8hq1F"),
    $6f5e560dcc8fec94$var$load("7FF6A"),
    $6f5e560dcc8fec94$var$load("henq4"),
    $6f5e560dcc8fec94$var$load("k5Ch2"),
    $6f5e560dcc8fec94$var$load("djob1"),
    $6f5e560dcc8fec94$var$load("8fMw3"),
    $6f5e560dcc8fec94$var$load("hogcU"),
    $6f5e560dcc8fec94$var$load("dAdaw"),
    $6f5e560dcc8fec94$var$load("h3ABO"),
    $6f5e560dcc8fec94$var$load("kC80R"),
    $6f5e560dcc8fec94$var$load("7EorR"),
    $6f5e560dcc8fec94$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.d58b6f91.js.map
